"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _withTheme = _interopRequireDefault(require("@material-ui/core/styles/withTheme"));

var _ensurePictureUrl = _interopRequireDefault(require("./helpers/ensurePictureUrl"));

var _usePictureUrlFromPerson = _interopRequireDefault(require("./helpers/usePictureUrlFromPerson"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _Avatar = _interopRequireDefault(require("./Avatar"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function Container(_ref) {
  var className = _ref.className,
      theme = _ref.theme,
      person = _ref.person,
      pictureUrlFromProps = _ref.pictureUrl,
      alt = _ref.alt;
  var displayName = (0, _get2["default"])(person, ['displayName']);
  var pictureUrlFromPerson = (0, _usePictureUrlFromPerson["default"])(person);

  var _pictureUrl = pictureUrlFromProps || pictureUrlFromPerson;

  var pictureUrl = (0, _ensurePictureUrl["default"])(_pictureUrl, theme);
  return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], {
    className: className,
    src: pictureUrl,
    alt: alt || displayName || 'Person'
  });
} // @ts-ignore


var _default = (0, _withTheme["default"])(Container);

exports["default"] = _default;